module.exports = __webpack_public_path__ + "img/no-agreements.1090808a.svg";